module.exports = __webpack_public_path__ + "img/document-text.7a7aa19c.svg";